<template>
  <div>
    <div class="home criacao">
      <template v-if="isPwa">
        <b-container fluid="lg" class="p-md-0 mb-2">
          <div class="d-flex align-items-center justify-content-between">
            <h1>Agenda de Estudos</h1>
          </div>
        </b-container>
      </template>
      <form-inputs />
    </div>
  </div>
</template>

<script>
import './style.scss'
import LoginUtils from '@/core/utils/login-utils'
import formInputs from '@/components/formInputs'

export default {
  name: 'Home',

  components: {
    formInputs
  },

  computed: {
    isPwa() {
      return LoginUtils.isPwa();
    }
  },
}
</script>
